import { render, staticRenderFns } from "./typeChart.vue?vue&type=template&id=5f08018e&scoped=true&"
import script from "./typeChart.vue?vue&type=script&lang=js&"
export * from "./typeChart.vue?vue&type=script&lang=js&"
import style0 from "./typeChart.vue?vue&type=style&index=0&id=5f08018e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f08018e",
  null
  
)

export default component.exports